<template>
  <van-tabs animated @change="onChangeTab" class="products-regular" sticky>
    <van-tab v-for="(val, ind) in tabbars" :title="val.name" :key="ind">
      <div class="the-top">
        <van-list class="tian-deail list" v-model="val.loading" :immediate-check="false" :finished="val.finished" :finished-text="val.finishedText" @load="getMoreProduct">
          <div v-for="(item, eq) in val.product_list" :key="eq" class="tian-deail">
            <div class="tian-item" @click.stop.prevent="onToDetail(item)">
              <div class="tian-item-main" :class="{ 'sold-out': isSoldOut(item) }">
                <div class="product-information">
                  <!-- name -->
                  <div class="title">
                    <span>{{ item.name }}</span>
                    <van-tag class="points" v-if="item.scoreRate > 0">返积分</van-tag>
                  </div>

                  <!-- tag -->
                  <div class="tag">
                    <van-tag class="tag1" v-if="item.label1" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label1 }}</van-tag>
                    <van-tag v-if="item.label2" class="tag2" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label2 }}</van-tag>
                    <van-tag v-if="item.attachLabel" plain color="#ff9900">{{
                      item.attachLabel
                    }}</van-tag>
                  </div>

                  <!-- data -->
                  <div class="data">
                    <!-- gain -->
                    <div class="gain">
                      <template v-if="item.ifStair">
                        <b>{{ rateInterval(item).minRate }}</b>
                        <span>%</span>
                        <span class="fuhao">~</span>
                        <b>{{ rateInterval(item).maxRate }}</b>
                        <span>%</span>
                      </template>
                      <template v-else>
                        <b>{{ item.expectedRate }}</b>
                        <span>%</span>
                        <template v-if="item.greenhandRate && item.greenhandRate > 0">
                          <span class="fuhao">+</span>
                          <b>{{ item.greenhandRate }}</b>
                          <span>%</span>
                        </template>
                      </template>
                      <!-- text -->
                      <div class="txt">预期年化收益率</div>
                    </div>

                    <!-- term -->
                    <div class="term">
                      <div class="term-box">
                        <!-- day -->
                        <div class="day">
                          <span class="s1">{{ item.investDuration }}</span>
                          <span class="s2">天</span>
                        </div>
                        <!-- text -->
                        <div class="txt">
                          {{ item.miniAmount / 1000000 }}万元起投
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- progress -->
                  <div class="progress">
                    <div class="progress-box">
                      <!-- progress-style -->
                      <div class="progress-style">
                        <div v-if="item.isFull || item.serverTime >= item.endTime" class="progress-pivot" style="width: 100%"></div>
                        <div v-else class="progress-pivot" :style="{ width: item.sold + '%' }"></div>
                      </div>
                      <!-- result -->
                      <div class="result">{{ progressText(item) }}</div>
                    </div>
                  </div>

                  <!-- 标签 -->
                  <div class="aside" v-if="
                      item.saleLabel === '1' && item.isFull <= item.endTime
                    ">
                    新手专享
                  </div>
                  <div :class="_isOnlyShowShuang11Icon() ? 'label-img' : 'aside'" v-if="
                      item.saleLabel === '2' && item.isFull <= item.endTime
                    ">
                    <img v-if="_isOnlyShowShuang11Icon()" style="width: 35px" class="hot-tag" src="../../../assets/img/common/shuang11-rate.jpg" alt />
                    <span v-else>{{
                      item.hotRate ? "热销加息" : "人气产品"
                    }}</span>
                  </div>
                  <div class="aside" v-if="
                      item.saleLabel === '4' && item.isFull <= item.endTime
                    ">
                    秒杀
                  </div>

                  <div v-if="item.isFull || item.serverTime >= item.endTime" class="signet-sold-out">
                    已结束
                  </div>

                  <!-- <img
                    v-if="item.isFull || item.serverTime >= item.endTime"
                    class="signet-sold-out"
                    src="../../../assets/img/invest/signet-sold-out.png"
                    alt
                  /> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 无数据，显示空 -->
          <van-empty description="暂无产品" v-if="val.product_list.length == 0"></van-empty>
        </van-list>
        <!--</div>-->
      </div>

      <!-- <div class="the-bottom">已经到底部了</div> -->
    </van-tab>
  </van-tabs>
</template>

<script>
import * as ProductApi from "@/api/product"
import { Tab, Tabs, Toast, Dialog, Tag, List, Empty } from "vant"
import storage from "@/utils/storage"

export default {
  name: "TianProductsRegular",

  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [List.name]: List,
    [Empty.name]: Empty
  },

  data() {
    return {
      pageSize: 15,
      currentIndex: 0,

      activeName: "全部产品",
      tabbars: [
        {
          name: "全部产品",
          tag: "all",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          finishedText: ""
        },
        {
          name: "3个月内",
          tag: "three",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          finishedText: ""
        },
        {
          name: "3-6个月",
          tag: "six",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          finishedText: ""
        },
        {
          name: "6个月以上",
          tag: "twelve",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          finishedText: ""
        }
      ]
    }
  },

  created() {
    this.onChangeTab(0)
  },

  methods: {
    // 利率
    rateInterval: function (item) {
      // console.info(n)
      if (item.ifStair) {
        let stairRate = item.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > item.stairRate["rate" + k]) {
              minRate = item.stairRate["rate" + k]
            }
            if (maxRate < item.stairRate["rate" + k]) {
              maxRate = item.stairRate["rate" + k]
            }
          }
        })
        return { minRate: minRate, maxRate: maxRate }
      }
    },
    // 新手专享 判断进度条展示状态
    isSoldOut(n) {
      return n.isFull || n.serverTime >= n.endTime
    },
    // 判断已售状态
    progressText: function (item) {
      // console.info(item);
      if (this.isSoldOut(item)) {
        return "100%"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    },
    onChangeTab(index) {
      this.currentIndex = index
      if (this.tabbars[index].product_list.length < 1) {
        this.getMoreProduct()
      }
    },

    getMoreProduct() {
      let current = this.tabbars[this.currentIndex]
      current.loading = true
      let the = this
      // 每次加载不超过15个产品，下拉加载更多
      ProductApi.productlistScore({
        investDuration: current.tag,
        pageNo: current.pageNo,
        pageSize: this.pageSize
      })
        .then((data) => {
          console.log(data)
          if (data.list != null) {
            current.product_list = current.product_list.concat(data.list)
          } else {
            data.list = []
            current.product_list = []
          }
          console.log(current.product_list)
          if (current.pageSize === 0 && data.list.length === 0) {
            current.finishedText = "暂无订单"
          } else if (data.list.length < the.pageSize) {
            // current.finishedText = "已经到底了";
            current.finished = true
          }
          current.pageNo++
          current.loading = false
        })
        .catch((e) => {
          current.finished = true
          current.loading = false
          Toast(e.msg || e.message)
        })
    },

    onToDetail(product) {
      this.$router.push({ path: "/detail", query: { productId: product.id } })
    }
  }
}
</script>

<style lang="less" scoped>
.the-top {
  padding-bottom: 50px;
}

::v-deep .van-tab--active {
  color: #333;
  font-weight: 700;
}
// 样式改版2020.7.29
.tian-item-main {
  margin: 10px 13px;
  position: relative;
  &.sold-out {
    filter: grayscale(0%) opacity(0.6);
  }
}

.product-information {
  padding: 14px 12px;
  border-radius: 5px;
  background-color: #fff;

  // name
  .title {
    font-size: 16px;
    height: 1.5em;
    overflow: hidden;
    color: #333333;
    word-break: break-all;
    .points {
      margin-left: 5px;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fc6524;
    }
  }
  // tag
  .tag {
    margin-left: -6px;
    .van-hairline--surround::after {
      border: none;
    }
    .van-tag {
      font-size: 10px;
    }
    .hide {
      display: none;
    }
    div {
      display: inline-block;
      height: 8px;
      width: 0.8px;
      background-color: #ff9900;
    }
  }
  // data
  .data {
    display: flex;
    align-items: center;
    // text
    .txt {
      color: #999;
      font-size: 14px;
    }
    // gain
    .gain {
      flex: 1;
      b {
        font-size: 36px;
        color: #fc6524;
        font-weight: normal;
      }
      span {
        font-size: 15px;
        color: #fc6524;
        margin-left: 1px;
      }
      .fuhao {
        font-size: 18px;
        color: #fc6524;
        margin: auto 5px;
      }
    }
    // term
    .term {
      flex: 1;
      text-align: center;
      .term-box {
        height: 72px;
        padding-right: 40px;
        // day
        .day {
          height: 53px;
          line-height: 53px;
          color: #666;
          .s1 {
            font-size: 22px;
          }
          .s2 {
            font-size: 18px;
            margin-left: 2px;
          }
        }
      }
    }
  }
  // progress
  .progress {
    margin-top: 10px;
    .progress-box {
      display: flex;
      align-items: center;
      // title
      .title {
        font-size: 11px;
        color: #666;
        margin-top: 3px;
      }
      // progress-style
      .progress-style {
        width: 250px;
        height: 7px;
        line-height: 16px;
        position: relative;
        background-color: #e9e9e9;
        border-radius: 7px;
        overflow: hidden;
        .progress-pivot {
          box-sizing: border-box;
          height: 100%;
          background-color: #fc6524;
          border-radius: 7px;
        }
      }
      // result
      .result {
        font-size: 14px;
        margin-left: 10px;
        color: #666;
      }
    }
  }
  .aside,
  .signet-sold-out {
    position: absolute;
    top: 18px;
    right: 0;
    padding: 0 12px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 25px 0 0 25px;
    color: #fff;
  }
  .signet-sold-out {
    background-color: #d6d6d7;
  }
  // 标签
  .aside {
    background-color: rgb(252, 101, 36);
  }
  .label-img {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 0;
  }
}
</style>
